import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        list: []
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
